import { processLoadedFolders } from '../actions/todoFolderStoreActions';
import { getStore } from '../store/store';
import type { TodoFoldersLoadState } from '../store/schema/TodoFoldersLoadState';
import type { TodoFolder } from 'owa-todo-types';
import { mutator, mutatorAction } from 'satcheljs';

// folders mutators
export const processLoadedFoldersMutator = mutator(processLoadedFolders, actionMessage => {
    const folders: TodoFolder[] = actionMessage.folders;
    if (folders.length == 0) {
        return;
    }
    const folderStore = getStore();
    folderStore.folders.clear();
    folders.forEach(folder => {
        folderStore.folders.set(folder.Id, folder);
    });
});

export const addFolder = mutatorAction('addFolder', (folder: TodoFolder) => {
    getStore().folders.set(folder.Id, folder);
});

// loadState mutators
export const setLoadState = mutatorAction('setLoadState', (loadState: TodoFoldersLoadState) => {
    getStore().loadState = loadState;
});
